import { render } from "./Show.vue?vue&type=template&id=7de0f6dd"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__